// Classes.
import {BooleanLocatorComponent} from './boolean.locator-component';

// Interfaces.
import {ComponentLocatorInterface} from '../interfaces/component-locator.interface';


export class DetailedLocatorComponent extends BooleanLocatorComponent implements ComponentLocatorInterface {


  public constructor(protected _value: boolean = false) {
    super();
  };

  public toString(): string {
    return this._value ? 'detailed' : 'nodetailed';
  }
}

